<template>
  <div>
    <Form ref="addModel" :model="addModel" :rules="ruleValidate" :label-width="110" inline>
      <FormItem label="字典类别名称" prop="DicCategroyName">
        <Input class="w-250" v-model="addModel.DicCategroyName"></Input>
      </FormItem>
      <FormItem label="字典类别代码" prop="DicCategroyCode">
        <Input placeholder="字典类别代码必须唯一" class="w-250" v-model="addModel.DicCategroyCode"></Input>
      </FormItem>

      <h3 class="mb-4">
        字典项数据
        <a class="ml-3" @click="addItem">添加字典项数据</a>
      </h3>
      <div class="dictionaryItems-panel">
        <div v-for="(item,index) in addModel.dictionaryItems">
          <FormItem label="字典值">
            <Input class="w-180" v-model="item.dictionaryValue"></Input>
          </FormItem>
          <FormItem label="字典代码">
            <Input class="w-180" v-model="item.dictionaryCode"></Input>
          </FormItem>
          <FormItem label="排序">
            <Input class="w-180" type="number" v-model="item.SortNum"></Input>
          </FormItem>
          <a class="ml-5" @click="deleteItem(index)">删除</a>
        </div>
      </div>
    </Form>
    <div class="mb-4 ml-5 text-center modal-foter">
      <Button class="mr-3" @click="close">取 消</Button>
      <Button class="mr-3" type="success" @click="addSubmit('addModel')">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      addModel: {
        DicCategroyName: "",
        DicCategroyCode: "",
        dictionaryItems: [
          //   {
          //     DictionaryValue: "",
          //     DictionaryCode: "",
          //     SortNum: 0,
          //   },
        ],
      },
      ruleValidate: {
        DicCategroyName: [
          {
            required: true,
            message: "字典类别名称不能为空",
          },
        ],
        DicCategroyCode: [
          {
            required: true,
            message: "字典类别代码不能为空",
          },
          { type: "string", max: 4, message: "最大长度4位", trigger: "blur" },
        ],
      },
    };
  },

  created: function () {},

  methods: {
    addSubmit(from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (this.addModel.dictionaryItems.length > 0) {
            for (let item of this.addModel.dictionaryItems) {
              if (!item.dictionaryValue) {
                this.$Message.warning("字典值不能为空");
                return false;
              }
            }
          }

          this.$api.post("dictionary/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.close();
              this.loadData();
              this.$refs[from].resetFields();
              this.addModel.dictionaryItems=[];
            }
          });
        }
      });
    },

    addItem() {
      var temp = { DictionaryValue: "", DictionaryCode: "", SortNum: "0" };
      this.addModel.dictionaryItems.push(temp);
    },

    deleteItem(index) {
      this.addModel.dictionaryItems.splice(index, 1);
    },

    close() {
      this.$emit("close");
    },
    loadData() {
      this.$emit("loadData");
    },
  },
};
</script>
<style scoped>
.w-180 {
  width: 120px;
}
.dictionaryItems-panel {
  max-height: 300 !important;
  overflow: auto;
}
</style>